import App, { Container } from 'next/app'
import React from 'react'
import { compose } from 'recompose'
import withReduxStore from '../components/hoc/withRedux'
import { Provider } from 'react-redux'
import AppWrapper from '../components/AppWrapper'
import { withI18next } from '../lib/withI18next'


class MyApp extends App {
  render () {
    const { Component, pageProps, reduxStore } = this.props
    return (
      <Container>
        <Provider store={reduxStore}>
          <AppWrapper>
            <Component {...pageProps} />
          </AppWrapper>
        </Provider>
      </Container>
    )
  }
}

export default compose(
  withReduxStore,
  withI18next('common')
)(MyApp)



// WEBPACK FOOTER //
// ./pages/_app.js